export default "__VITE_ASSET__5f78f2a5__"